import { Dispatch } from '@reduxjs/toolkit';
import { filter, keyBy, uniqBy } from 'lodash/fp';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { AccountStatus } from 'dashboard/models/account-status';
import { AccountType, AccountTypesFiltersResponse } from 'dashboard/models/account-type';
import {
  setAccountTypes,
  setAccountTypesFilterOptions,
} from 'dashboard/redux/actions/account-types';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export function loadAccountTypes() {
  return async (dispatch: Dispatch) => {
    const accountTypesResponse = await SessionClientDashboard.listResource<
      AccountType,
      Record<string, unknown>
    >(ApiEndpoint.AccountType, {});

    const includedItemsMap = keyBy('id', accountTypesResponse.included);
    const allAccountStatuses = filter(
      (apiRelationship) => apiRelationship.type === ApiModel.AccountStatus,
      includedItemsMap,
    ) as AccountStatus[];
    const accountStatuses = uniqBy('id', allAccountStatuses);

    const accountTypes = accountTypesResponse.data;
    dispatch(setAccountTypes(accountTypes, accountStatuses));
  };
}

export const loadAccountTypesFilterOptions = () => {
  return async (dispatch: Dispatch) => {
    const { meta } = await SessionClientDashboard.get<AccountTypesFiltersResponse>(
      ApiEndpoint.AccountType,
      'basics',
      '',
      {},
    );

    dispatch(setAccountTypesFilterOptions(meta.filters));
  };
};
